import { FunctionComponent } from "react";
import styles from "./Home.module.css";

const Home: FunctionComponent = () => {
  return (
    <div className={styles.homeDiv}>
      <div className={styles.heroiconsOutlineviewGridAdDiv} />
      <img
        className={styles.bytesizesearchIcon}
        alt=""
        src="../bytesizesearch.svg"
      />
      <div className={styles.groupDiv}>
        <img className={styles.rectangleIcon} alt="" src="../rectangle-7.svg" />
        <div className={styles.rectangleDiv} />
        <div className={styles.groupDiv1}>
          <div className={styles.rectangleDiv1} />
          <img
            className={styles.rectangleIcon1}
            alt=""
            src="../rectangle-9.svg"
          />
          <div className={styles.groupDiv2}>
            <div className={styles.balanceDiv}>Balance:</div>
            <div className={styles.div}>$5,000.</div>
          </div>
          <div className={styles.div1}>7345 7642 5894 ****</div>
          <img className={styles.epviewIcon} alt="" src="../epview.svg" />
        </div>
        <img className={styles.groupIcon} alt="" src="../group-1.svg" />
      </div>
      <img className={styles.groupIcon1} alt="" src="../group-33.svg" />
      <div className={styles.groupDiv3}>
        <div className={styles.groupDiv4}>
          <div className={styles.rectangleDiv2} />
          <div className={styles.rectangleDiv3} />
        </div>
        <div className={styles.spendingAccountDiv}>Spending Account</div>
        <div className={styles.savingsAccountDiv}>Savings Account</div>
      </div>
      <img className={styles.groupIcon2} alt="" src="../group-35.svg" />
      <img className={styles.rectangleIcon2} alt="" src="../rectangle-3.svg" />
      <div className={styles.groupDiv5}>
        <div className={styles.loanPaymentDiv}>Loan payment:</div>
        <div className={styles.div2}>$900</div>
        <div className={styles.dueBy18Aug}>Due by 18, Aug</div>
      </div>
      <div className={styles.beneficiariesDiv}>Beneficiaries</div>
      <div className={styles.transactionsDiv}>Transactions</div>
      <div className={styles.groupDiv6}>
        <div className={styles.groupDiv7}>
          <img className={styles.ellipseIcon} alt="" src="../ellipse-11.svg" />
          <div className={styles.tADiv}>TA</div>
        </div>
        <img className={styles.ellipseIcon} alt="" src="../group-43.svg" />
        <div className={styles.tadicArnoldDiv}>
          <p className={styles.tadicP}>Tadic</p>
          <p className={styles.arnoldP}>Arnold</p>
        </div>
        <div className={styles.searchDiv}>Search</div>
        <div className={styles.groupDiv8}>
          <div className={styles.ellipseIcon}>
            <img
              className={styles.ellipseIcon}
              alt=""
              src="../ellipse-12.svg"
            />
            <div className={styles.aJDiv}>AJ</div>
          </div>
          <div className={styles.arnoldJohnDiv}>
            <p className={styles.tadicP}>Arnold</p>
            <p className={styles.arnoldP}>John</p>
          </div>
        </div>
        <div className={styles.groupDiv10}>
          <div className={styles.ellipseIcon}>
            <img
              className={styles.ellipseIcon}
              alt=""
              src="../ellipse-13.svg"
            />
            <div className={styles.tADiv}>EY</div>
          </div>
          <div className={styles.ethanYondaDiv}>
            <p className={styles.tadicP}>Ethan</p>
            <p className={styles.arnoldP}>Yonda</p>
          </div>
        </div>
        <div className={styles.groupDiv12}>
          <div className={styles.ellipseIcon}>
            <img
              className={styles.ellipseIcon}
              alt=""
              src="../ellipse-11.svg"
            />
            <div className={styles.bTDiv}>BT</div>
          </div>
          <div className={styles.ethanYondaDiv}>
            <p className={styles.tadicP}>Ben</p>
            <p className={styles.arnoldP}>Teddy</p>
          </div>
        </div>
        <div className={styles.groupDiv14}>
          <div className={styles.ellipseIcon}>
            <img
              className={styles.ellipseIcon}
              alt=""
              src="../ellipse-15.svg"
            />
            <div className={styles.aJDiv}>PJ</div>
          </div>
          <div className={styles.ethanYondaDiv}>
            <p className={styles.tadicP}>Ben</p>
            <p className={styles.arnoldP}>Teddy</p>
          </div>
        </div>
      </div>
      <div className={styles.groupDiv16}>
        <img className={styles.ellipseIcon5} alt="" src="../ellipse-111.svg" />
        <div className={styles.tADiv1}>TA</div>
      </div>
      <div className={styles.groupDiv17}>
        <img className={styles.ellipseIcon5} alt="" src="../ellipse-112.svg" />
        <div className={styles.tADiv1}>AJ</div>
      </div>
      <div className={styles.groupDiv18}>
        <img className={styles.ellipseIcon5} alt="" src="../ellipse-112.svg" />
        <div className={styles.tADiv1}>BT</div>
      </div>
      <div className={styles.rectangleDiv4} />
      <div className={styles.groupDiv19}>
        <div className={styles.searchDiv1}>Search</div>
        <img className={styles.fesearchIcon} alt="" src="../fesearch.svg" />
      </div>
      <div className={styles.todayDiv}>Today</div>
      <div className={styles.groupDiv20}>
        <div className={styles.tadicArnoldDiv1}>Tadic Arnold</div>
        <div className={styles.pmDiv}>2:30pm</div>
      </div>
      <div className={styles.groupDiv21}>
        <div className={styles.arnoldJohnDiv1}>Arnold John</div>
        <div className={styles.pmDiv1}>2:30pm</div>
      </div>
      <div className={styles.groupDiv22}>
        <div className={styles.tadicArnoldDiv1}>Ben Teddy</div>
        <div className={styles.pmDiv1}>2:30pm</div>
      </div>
      <div className={styles.lineDiv} />
      <div className={styles.lineDiv1} />
      <div className={styles.debitDiv}>debit</div>
      <div className={styles.creditDiv}>credit</div>
      <div className={styles.creditDiv1}>credit</div>
      <div className={styles.div3}>-$4.000.</div>
      <div className={styles.div4}>+$3.000.</div>
      <div className={styles.div5}>+$3.000.</div>
      <div className={styles.lineDiv2} />
      <img className={styles.rectangleIcon3} alt="" src="../rectangle-35.svg" />
      <img className={styles.groupIcon4} alt="" src="../group-67.svg" />
      <div className={styles.homeDiv1}>Home</div>
      <img className={styles.ellipseIcon8} alt="" src="../ellipse-18@2x.png" />
      <img
        className={styles.carbonnotificationNewIcon}
        alt=""
        src="../carbonnotificationnew.svg"
      />
      <div className={styles.groupDiv23}>
        <div className={styles.helloWelcomeBack}>Hello, Welcome Back!</div>
        <div className={styles.arnoldOwenDiv}>Arnold Owen</div>
      </div>
      <div className={styles.settingsDiv}>Settings</div>
      <div className={styles.frameDiv}>
        <div className={styles.groupDiv24}>
          <div className={styles.rectangleDiv5} />
          <div className={styles.groupDiv25}>
            <div className={styles.groupDiv26}>
              <div className={styles.transferDiv}>{`Transfer `}</div>
              <img className={styles.groupIcon5} alt="" src="../group-48.svg" />
            </div>
          </div>
        </div>
        <div className={styles.groupDiv27}>
          <div className={styles.groupDiv28}>
            <div className={styles.rectangleDiv6} />
          </div>
          <div className={styles.groupDiv29}>
            <div className={styles.transferDiv}>Deposit</div>
            <img className={styles.groupIcon6} alt="" src="../group-51.svg" />
          </div>
        </div>
        <div className={styles.groupDiv24}>
          <div className={styles.groupDiv28}>
            <div className={styles.rectangleDiv5} />
            <div className={styles.groupDiv32}>
              <div className={styles.fa6SolidmoneyBillTransferDiv} />
            </div>
          </div>
          <div className={styles.groupDiv33}>
            <div className={styles.groupDiv34}>
              <img className={styles.vectorIcon} alt="" src="../vector.svg" />
              <div className={styles.transferDiv}>Pay Bill</div>
            </div>
          </div>
        </div>
        <div className={styles.groupDiv27}>
          <div className={styles.groupDiv28}>
            <div className={styles.rectangleDiv8} />
            <div className={styles.groupDiv32}>
              <div className={styles.fa6SolidmoneyBillTransferDiv} />
            </div>
          </div>
          <div className={styles.groupDiv38}>
            <img className={styles.vectorIcon1} alt="" src="../vector1.svg" />
            <div className={styles.transferDiv}>More</div>
          </div>
        </div>
      </div>
      <div className={styles.cardsDiv}>Cards</div>
      <img className={styles.vectorIcon2} alt="" src="../vector2.svg" />
      <img className={styles.vectorIcon3} alt="" src="../vector3.svg" />
      <img className={styles.groupIcon7} alt="" src="../group.svg" />
      <img
        className={styles.fluentinprivateAccount20ReIcon}
        alt=""
        src="../fluentinprivateaccount20regular.svg"
      />
      <img className={styles.groupIcon8} alt="" src="../group-65.svg" />
      <img className={styles.vectorIcon4} alt="" src="../vector4.svg" />
      <div className={styles.walletsDiv}>Wallets</div>
      <div className={styles.frameDiv1}>
        <div className={styles.payNowDiv}>Pay Now</div>
      </div>
      <div className={styles.accountDiv}>Account</div>
    </div>
  );
};

export default Home;
